export default "__VITE_ASSET__8aed28c4__"